(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvBankAccountNumberInput', drvBankAccountNumberInput);
        
    drvBankAccountNumberInput.$inject = [];

        /**
         * @ngdoc directive
         * @name drvBankAccountNumberInput
         * @description Bank Account Number input which includes validation.
         *
         * @param {string} value - Bank Account Number
         * @param {object} field - An entity field object
         */
        function drvBankAccountNumberInput() {
            drvBankAccountNumberInputCtrl.$inject = [];

            return  {
                templateUrl: 'app/fieldinput/bank-account-number-input.tmpl.html',
                require: "ngModel",
                scope: {
                },
                controller: drvBankAccountNumberInputCtrl,
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel',
                    field: '='
                },
                link: link
            };

            function drvBankAccountNumberInputCtrl() {
                /* jshint validthis:true */
                var drvCtrl = this;
                drvCtrl.validateBankAccountNumber = validateBankAccountNumber;

                /*
                 * Check to see if the Bank Account Number is valid
                 */
                function validateBankAccountNumber(bankAccountNumber) {
                    var valid = false;

                    if (!_.isNil(bankAccountNumber) && bankAccountNumber !== '') {
                        if (bankAccountNumber.length >= 6 && bankAccountNumber.length <= 10 && !isNaN(bankAccountNumber)) {
                            valid = true;
                        }
                    } else {
                        valid = true;
                    }

                    return valid;
                }
            }
        }

        /*
         * Link function which will handle validation
         */
        function link($scope, $element, $attrs, $ctrl) {
            $scope.pni[$scope.drvCtrl.field.Name].$validators.formatValid = function required(modelValue, viewValue) {
                return $scope.drvCtrl.validateBankAccountNumber(modelValue);
            };
        }
})();